import { forOwn, map, union } from 'lodash';
import { createSelector } from 'reselect';
import { getSchemaSpecEntities } from '../entities';

const getSchemaSpecs = (state) => state.schemaSpecs;

export const getVisibleSchemaSpecs = createSelector(
  [getSchemaSpecs, getSchemaSpecEntities],
  (schemaSpecs, entities) => {
    const { sortedIds, sortedPublicIds, flatSchemas, flatSamples } = schemaSpecs;

    return map(union(sortedIds, sortedPublicIds), (id) => ({
      ...entities[id],
      flatSchema: flatSchemas[id],
      flatSamples: flatSamples[id],
    }));
  },
);

export const getSchemaSpecList = createSelector(
  [getSchemaSpecs, getSchemaSpecEntities],
  (schemaSpecs, entities) => {
    const { listing, flatSchemas, flatSamples } = schemaSpecs;

    return map(listing, (id) => ({
      ...entities[id],
      flatSchema: flatSchemas[id],
      flatSamples: flatSamples[id],
    }));
  },
);
